import Repository from "./repository"

export default {
    /**
     * アクセス権限確認のためのコントローラ呼び出し
     */
    view() {
        return Repository.get('/api/s205-chat-contract-order/view')
    },
    /**
     * 入力されたサービス内容の妥当性チェック
     * @param {*} params 入力されたサービス内容
     * @returns response
     */
    check(params) {
        return Repository.post('/api/s205-chat-contract-order/check', params)
    },
    /**
     * ChutLuckご契約お申し込みの内容をDBに登録する
     * @param {*} params 入力されたサービス内容
     * @returns response
     */
    add(params) {
        return Repository.post('/api/s205-chat-contract-order/add', params)
    }
}